export const formatDate = (dateString: string | Date, options?: Intl.DateTimeFormatOptions): string => {
  const date = new Date(dateString)
  
  if (isNaN(date.getTime())) {
    return 'Invalid Date'
  }

  const defaultOptions: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  }

  return date.toLocaleDateString('en-US', { ...defaultOptions, ...options })
}

export const formatDateTime = (dateString: string | Date): string => {
  return formatDate(dateString, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })
}

export const formatDateLong = (dateString: string | Date): string => {
  return formatDate(dateString, {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  })
}

export const formatDateInput = (dateString: string | Date): string => {
  const date = new Date(dateString)
  
  if (isNaN(date.getTime())) {
    return ''
  }

  return date.toISOString().split('T')[0]
}

export const isValidDate = (dateString: string): boolean => {
  const date = new Date(dateString)
  return !isNaN(date.getTime())
}

export const addDays = (date: Date, days: number): Date => {
  const result = new Date(date)
  result.setDate(result.getDate() + days)
  return result
}

export const subtractDays = (date: Date, days: number): Date => {
  return addDays(date, -days)
}

export const isSameDay = (date1: Date, date2: Date): boolean => {
  return date1.toDateString() === date2.toDateString()
}

export const isToday = (date: Date): boolean => {
  return isSameDay(date, new Date())
}

export const daysDifference = (date1: Date, date2: Date): number => {
  const timeDifference = Math.abs(date2.getTime() - date1.getTime())
  return Math.ceil(timeDifference / (1000 * 60 * 60 * 24))
}